import { SvgIconProps } from "@mui/material";

export const RotateXAxis = (props: SvgIconProps) => {
    return (
        <svg
            fill="#838280"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M14.9868494,12.7202574 L13.8535534,13.8535534 C13.6582912,14.0488155 13.3417088,14.0488155 13.1464466,13.8535534 C12.9511845,13.6582912 12.9511845,13.3417088 13.1464466,13.1464466 L15.1464466,11.1464466 C15.3417088,10.9511845 15.6582912,10.9511845 15.8535534,11.1464466 L17.8535534,13.1464466 C18.0488155,13.3417088 18.0488155,13.6582912 17.8535534,13.8535534 C17.6582912,14.0488155 17.3417088,14.0488155 17.1464466,13.8535534 L15.9884871,12.6955939 C15.8167229,17.8651676 13.7413901,22 11,22 C8.13669069,22 6,17.4892085 6,12 C6,6.51079147 8.13669069,2 11,2 C12.5021775,2 13.8263891,3.23888365 14.7433738,5.30744582 C14.8552836,5.55989543 14.7413536,5.8552671 14.4889039,5.96717692 C14.2364543,6.07908673 13.9410827,5.96515672 13.8291729,5.71270711 C13.0550111,3.96632921 12.0221261,3 11,3 C8.89274656,3 7,6.99579829 7,12 C7,17.0042017 8.89274656,21 11,21 C13.0051086,21 14.8160018,17.3821896 14.9868494,12.7202574 Z" />
        </svg>
    );
};
